import { fetch } from 'whatwg-fetch'
import { chartPlugins } from './chart-plugins'
import { getAverageData, getAverageOptions, getResponsiveOptions } from './chart-settings'
import { formatNumber } from './utils/format-number'
import Chartist from 'chartist'

export class AverageEpexChart {
  constructor () {
    this.chartElement = document.querySelector('#average_epex')
    this.nettoSwitch = document.querySelector('#average-netto-button')
    this.bruttoSwitch = document.querySelector('#average-brutto-button')
    this.currentDateSelector = document.querySelector('.average-epex-popup .current-date')
    this.prevDateButton = document.querySelector('.average-epex-popup .prev-date')
    this.nextDateButton = document.querySelector('.average-epex-popup .next-date')
    this.isBrutto = false
    this.nettoDataset = []
    this.bruttoDataset = []
    this.activeDataset
    this.todaysDate
    this.changedDate
    this.storageDate
    this.index = 0

    chartPlugins()
  }

  init () {
    const url = `${window.location.origin}/?type=9997`

    this.initEventListeners(url)

    this.buildChart(url)
  }

  initEventListeners (url) {
    // Toggle to brutto prices
    this.bruttoSwitch.addEventListener('change', event => {
      if (!this.isBrutto) {
        this.isBrutto = true
        this.updateChartDataset()
      }
    })

    // Toggle to netto prices
    this.nettoSwitch.addEventListener('change', event => {
      if (this.isBrutto) {
        this.isBrutto = false
        this.updateChartDataset()
      }
    })

    // Click for the prices of the previous Day
    this.prevDateButton.addEventListener('click', () => this.prevDate(url))

    // Click for the prices of the next Day
    this.nextDateButton.addEventListener('click', () => this.nextDate(url))
  }

  // Get data from url
  // Build chart from dataset
  buildChart (url) {
    return fetch(url)
      .then((response) => response.json())
      .catch((error) => console.error(`Average EPEX-Preise konnten nicht geladen werden: ${error}`))
      .then((res) => {
        if (!this.todaysDate) {
          this.todaysDate = new Date(res[1].date * 1000)
          this.storageDate = new Date(res[1].date * 1000)
        }

        if (!this.currentDateSelector.innerHTML) {
          this.setCurrentDate(this.todaysDate)
        }

        this.bruttoDataset = []
        this.nettoDataset = []

        return this.createPriceDatasets(res[0].prices)
      })
      .then(() => {
        this.setPriceHighlights()
      })
      .then(() => {
        this.singleChart = new Chartist.Bar('#average_epex', getAverageData(!this.isBrutto ? this.nettoDataset : this.bruttoDataset), getAverageOptions(Math.max.apply(Math, this.bruttoDataset), Math.min.apply(Math, this.nettoDataset)))

        // Once the chart is fully created we reset the sequence
        this.singleChart.on('created', () => {
          //this.highlightBarForCurrentHour(this.currentHour)

          this.fadeInTooltips()
        })
      })
  }

  prevDate (url) {
    if (this.storageDate.getFullYear() <= 2021) return

    this.changedDate = new Date(this.storageDate.setFullYear(this.storageDate.getFullYear() - 1))

    this.dateChangeHandler(url)
  }

  nextDate (url) {
    if (this.storageDate.getFullYear() >= this.todaysDate.getFullYear()) return

    this.changedDate = new Date(this.storageDate.setFullYear(this.storageDate.getFullYear() + 1))

    this.dateChangeHandler(url)
  }

  dateChangeHandler (url) {
    Array.prototype.slice.call(document.querySelectorAll('.tooltip')).forEach((tip) => {
      tip.parentNode.removeChild(tip)
    })

    this.index++
    this.setCurrentDate(this.changedDate)

    const newUrl = `${url}&tx_voltegoprice_average_price[day]=${this.currentDate}&tx_voltegoprice_average_price[month]=${this.currentMonth}&tx_voltegoprice_average_price[year]=${this.currentYear}`

    this.singleChart.detach()
    this.buildChart(newUrl)
  }

  updateChartDataset () {
    this.singleChart.data.series[0] = !this.isBrutto ? this.nettoDataset : this.bruttoDataset
    this.setPriceHighlights()
    this.singleChart.update()

    //this.highlightBarForCurrentHour(this.currentHour)
    this.fadeInTooltips()
  }

  createPriceDatasets (response) {
    let index = 0
    let begin = false
    response.forEach(price => {
      if (begin == false) {
        if (price.priceMonth == 1 && price.priceYear == this.currentYear) {
          begin = true
        }
      }

      if (begin == true && index < 12) {
        this.bruttoDataset.push(price.priceAmount * 1.19)
        this.nettoDataset.push(price.priceAmount)

        if (this.currentHour === price.priceHour) {
          if (this.isBrutto) {
            this.putCurrentValue(price.priceAmount * 1.19)
          }
          else {
            this.putCurrentValue(price.priceAmount)
          }

          this.bruttoSwitch.addEventListener('change', event => {
            this.putCurrentValue(price.priceAmount * 1.19)
          })
          this.nettoSwitch.addEventListener('change', event => {
            this.putCurrentValue(price.priceAmount)
          })
          price.isActive = true
        }
        index++;
      }



    })

    while (index < 12) {
        index++;
        this.bruttoDataset.push(0)
        this.nettoDataset.push(0)
    }

  }

  putCurrentValue (value) {
    const selectors = document.getElementsByClassName('price-per-hour')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(value)
    })
  }

  fadeInTooltips () {
    const texts = Array.prototype.slice.call(this.chartElement.querySelectorAll('.ct-barlabel'))

    setTimeout(() => {
      texts.forEach(singleText => {
        singleText.classList.add('is-visible')
      })
    }, 100)
  }

  putMaxValue (isBrutto, nettoDataset, bruttoDataset) {
    const maxValue = Math.max.apply(Math, !isBrutto ? nettoDataset : bruttoDataset)
    const selectors = document.getElementsByClassName('highest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(maxValue)
    })
  }

  // Output the lowest value of the array in given selector
  putMinValue (isBrutto, nettoDataset, bruttoDataset) {
    const minValue = Math.min.apply(Math, !isBrutto ? nettoDataset : bruttoDataset)
    const selectors = document.getElementsByClassName('lowest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(minValue)
    })
  }

  // Helper function
  // See functions below
  setPriceHighlights () {
    this.putMaxValue(this.isBrutto, this.nettoDataset, this.bruttoDataset)
    this.putMinValue(this.isBrutto, this.nettoDataset, this.bruttoDataset)
    this.putAvgValue()
  }

  // Hightlighting the price of the current Hour
  highlightBarForCurrentHour (hour) {
    const lines = Array.prototype.slice.call(this.chartElement.querySelectorAll('line'))

    if (lines[hour] && this.todaysDate.getDate() === this.storageDate.getDate()) {
      lines[hour].style.opacity = 1
    }

    // Centering the highlighted bar on mobile
    if (window.innerWidth <= 1024 && this.todaysDate.getDate() === this.storageDate.getDate()) {
      const epexForm = this.chartElement.getBoundingClientRect()
      const priceWrapper = document.querySelector('.price-wrapper')
      const leftOfLine = lines[hour].getBoundingClientRect().left

      priceWrapper.scrollLeft = leftOfLine - epexForm.left - 36
    }
  }

  // Output the average value of the array in given selector
  putAvgValue () {
    this.activeDataset = !this.isBrutto ? this.nettoDataset : this.bruttoDataset
    if (this.activeDataset.length) {
      const sumValue = this.activeDataset.reduce((previous, current) => parseFloat(current) + parseFloat(previous))
      const avgValue = sumValue / this.activeDataset.length
      const selector = document.querySelector('.average-price')
      selector.innerHTML = formatNumber(avgValue)
    }
  }

  // Gets the current date and outputs it into the given selector
  setCurrentDate (date) {
    this.currentHour = date.getHours()
    this.currentDate = date.getDate()
    this.currentMonth = (date.getMonth() + 1)
    this.currentYear = date.getFullYear()

    if (this.currentDate < 10) {
      this.currentDate = `0${this.currentDate}`
    }

    if (this.currentMonth < 10) {
      this.currentMonth = `0${this.currentMonth}`
    }

    //this.currentDayDE = `${this.currentDate}.${this.currentMonth}.${this.currentYear}`
    this.currentDayDE = `${this.currentYear}`

    this.currentDateSelector.innerHTML = this.currentDayDE
  }
}

export function averageChart () {

    if (document.querySelector('#average_epex') === null) {
      return
    }

    const epexChart = new AverageEpexChart()
    epexChart.init()

}
